import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';
import CompanyIconSVG from '@/assets/icons/greyCompanyIcon.svg?react';

export const ResizeCont = styled.div`
  cursor: pointer;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 16px;

  svg {
    width: 10.5px;
    height: 20.92px;
  }
  ${({ theme }: IThemeProvider) => `
    margin: 0 18px 0 0;
  `};
`;

export const ReportsTileCont = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.mikro};
  `};
`;

export const ReportTypeCont = styled.div`
  width: 120px;
  display: flex;
  align-items: center;
  padding: 6px 0 6px 8px;

  svg {
    width: 22px;
    height: 22px;
  }

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.secondary[10]};
    border-radius: 
    ${theme.layout.spacing.giga} 
    ${theme.layout.spacing.nano} 
    ${theme.layout.spacing.nano} 
    ${theme.layout.spacing.giga};
  `};
`;

export const ReportTypeText = styled(LabelRegularBoldM)`
  text-transform: uppercase;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const EffectTypeText = styled(LabelRegularBoldM)`
  text-transform: lowercase;
  font-style: italic;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  font-size: 16px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const OverviewCont = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
    margin: 0 0 0 ${theme.layout.spacing.centy};
  `};
`;

export const ReportGroupTitle = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.nano} 0;
  `};
`;

export const DetailsCont = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 19px;
  width: 350px;
`;

export const ReportGroupCompany = styled.span`
  font-weight: 500;
  ${({ theme }: IThemeProvider) => `
    margin: 0 auto 0 ${theme.layout.spacing.nano};
  `};
`;

export const CompanyIcon = styled(CompanyIconSVG)`
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.nano} 0 0;
  `};
`;
